import Vue from 'vue'
import Vuex from 'vuex'
import auth from './auth'
import application from './application'
import user from './user'
import job from './job'
import dashboard from './dashboard'
import company from './company'
import candidate from './candidate'
import recruiter from './recruiter'
import industry from './industry'
import interview from './interview'
import func from './function'
import currency from './currency'
import timezone from './timezone'
import prospect from './prospect'
import finance from './finance'
import email_template from './email_template'
import brand from './brand'
import hrflow from './hrflow'
import webcrawler from './webcrawler'
import role from './role'
import candidate_source from './candidate_source'
import category from './category'
import tag from './tag'
import exam from './exam'
import user_signup from './user_signup'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    application,
    user,
    job,
    dashboard,
    company,
    candidate,
    recruiter,
    industry,
    interview,
    function:func,
    currency,
    timezone,
    prospect,
    finance,
    email_template,
    brand,
    hrflow,
    webcrawler,
    role,
    candidate_source,
    category,
    tag,
    exam,
    user_signup
  },
  state: {
  },
  mutations: {
  },
  actions: {
  }
})
